<!-- Default mode: simple dialog -->
@if (mode === 'default') {
  <div class="modal-dialog-wrap">
    <button type="button" class="modal-dialog-close" [attr.aria-label]="closeLabel" (click)="close()">
      <span class="material-symbols-outlined">close</span>
    </button>
    @if (icon) {
      <div class="modal-dialog-icon">
        <span class="material-symbols-outlined">{{ icon }}</span>
      </div>
    }
    @if (image) {
      <div class="modal-dialog-icon">
        <img [src]="image" [alt]="title || 'Icon'">
      </div>
    }
    @if (title) {
      <h3 class="modal-dialog-title">{{ title }}</h3>
    }
    @if (message) {
      <p class="modal-dialog-message">{{ message }}</p>
    }
    @if (buttons.length) {
      <div class="modal-dialog-actions">
        @for (btn of buttons; track btn) {
          <button
            type="button"
            class="modal-dialog-btn"
            [ngClass]="'modal-dialog-btn--' + btn.style"
            (click)="onButton(btn)">
            {{ btn.label }}
          </button>
        }
      </div>
    }
  </div>
}

<!-- Content mode: custom body with header -->
@if (mode === 'content') {
  <div class="modal-content-wrap">
    <div class="modal-content-header">
      @if (title) {
        <h3 class="modal-content-title">{{ title }}</h3>
      }
      <div class="modal-content-header-actions">
        @for (action of headerActions; track action) {
          <button
            type="button"
            class="modal-dialog-btn modal-dialog-btn--header"
            [ngClass]="'modal-dialog-btn--' + action.style"
            [disabled]="action.loading"
            (click)="onHeaderAction(action)"
            >
            @if (!action.loading) {
              <span>{{ action.label }}</span>
            }
            @if (action.loading) {
              <span class="modal-content-spinner"></span>
            }
          </button>
        }
        <button type="button" class="modal-dialog-close modal-dialog-close--inline" [attr.aria-label]="closeLabel" (click)="close()">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
    </div>
    <div class="modal-content-body">
      @if (contentTemplate) {
        <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
      }
    </div>
  </div>
}
